import { useCoreEntityStore } from '@/pinia/coreEntity'
import { getPoiById } from '@/services/pois.service'
import { getRealmId } from '@/utils/realmId'
import { getLineLayerById } from '@/services/lines.service'
import { getZoneLayerById } from '@/services/zones.service'
import * as Sentry from '@sentry/browser'

const coreEntityTypes = ['COMPLEX', 'REAL_ESTATE', 'CONSTRUCTION', 'LEVEL', 'SPACE']

export async function getEntityParents(
  entityId: string,
  entityType: string
): Promise<string | undefined> {
  const coreEntityStore = useCoreEntityStore()
  try {
    let parents
    if (coreEntityTypes.includes(entityType)) {
      const currentEntity = await coreEntityStore.getCoreEntity(entityId)
      const parentNames = await coreEntityStore.getParents(entityId)
      parents = [...parentNames, currentEntity]
    } else if (entityType === 'POI') {
      const poi = await getPoiById(entityId)
      if (!poi) return undefined
      const currentEntity = await coreEntityStore.getCoreEntity(poi.coreId)
      const parentNames = await coreEntityStore.getParents(poi.coreId)
      parents = [...parentNames, currentEntity, poi]
    } else if (entityType === 'ZONE') {
      const zone = await getZoneLayerById(entityId)
      if (!zone) return undefined
      const currentEntity = await coreEntityStore.getCoreEntity(zone.coreId)
      const parentNames = await coreEntityStore.getParents(zone.coreId)
      parents = [...parentNames, currentEntity, zone]
    } else if (entityType === 'LINE') {
      const line = await getLineLayerById(entityId)
      if (!line) return undefined
      const currentEntity = await coreEntityStore.getCoreEntity(line.coreId)
      const parentNames = await coreEntityStore.getParents(line.coreId)
      parents = [...parentNames, currentEntity, line]
    } else {
      // case realm
      parents = [{ name: getRealmId() }]
    }
    if (!parents) return undefined
    const parentNames = [...parents].map((parent) => parent.name).join(', ')
    return parentNames
  } catch (error) {
    Sentry.captureException(error)
    return undefined
  }
}
